module.exports = __webpack_public_path__ + "static/media/27OCHA13.a85675fb.jpg";